import * as Yup from "yup";

export const schema = Yup.object().shape({
  talinkUsername: Yup.string().required("Please enter your talink username"),
  password: Yup.string().required("Please enter your password"),

  authStrategy: Yup.string(),
  identifier: Yup.string().when("strategy", {
    is: "native",
    then: Yup.string().required("Please enter your staff username"),
  }),
  mfaRequired: Yup.boolean(),
  mfaCodeSent: Yup.boolean().optional(),
  mfaCode: Yup.string().when("mfaCodeSent", {
    is: (b: string) => !!b,
    then: Yup.string().required("Please enter your 6 digit code"),
  }),
  mfaStrategy: Yup.string().when("mfaRequired", {
    is: (b: boolean) => {
      return b == true;
    },
    then: Yup.string().required("Please select mfa strategy"),
  }),
});
